import { all, fork } from 'redux-saga/effects'
import { appSagas } from './app/app.sagas'

export function* globalSagas() {
  yield all([
    fork(appSagas),
    // place all of your sagas here
  ])
}
